{
  "home": {
    "title": "الرئيسية",
    "branch": "الفرع",
    "businessDate": "تاريخ العمل",
    "employee": "الموظف",
    "product": {
      "label": "المادة",
      "DIESEL": "محروقات",
      "PETROL": "بنزين",
      "confirmSwitchTitle": "التبديل إلى بنزين؟",
      "confirmSwitchDescription": "ستعمل الشاشات التالية على البنزين بدلا من المحروقات. يمكنك التبديل مرة أخرى في أي وقت.",
      "confirmSwitchConfirm": "تبديل"
    },
    "purchase": "شراء",
    "delivery": "بيع",
    "deliverySubtitle": "تسليم وصل بيع",
    "recent": "آخر عملياتي",
    "frozen": "النظام مجمد مؤقتا لعملية إدارة السنوات",
    "noServices": "لا تملك صلاحية استخدام هذا التطبيق",
    "noProducts": "لا تملك صلاحية أي مادة",
    "inventoryMode": "وضع الجرد مفعل: تحفظ المشتريات والمبيعات معلقة حتى ترحيلها",
    "noShift": "لا يوجد شفت مفتوح حاليا. يرجى الانتظار حتى يتم فتح شفت جديد قبل إجراء أي حركة."
  },
  "header": {
    "menu": "قائمة الحساب"
  },
  "flow": {
    "back": "رجوع",
    "next": "التالي",
    "stepHeader": "{{n}} من 3",
    "backHome": "الرئيسية",
    "loadError": "تعذر تحميل البيانات",
    "retry": "تحديث",
    "noAccess": "لا تملك صلاحية هذه الشاشة",
    "optionRemoved": "خيار الكمية المحدد لم يعد متاحا، وتم حذف العدد الذي أدخلته له. راجع الكميات.",
    "frozen": "النظام مجمد مؤقتا لعملية إدارة السنوات",
    "noProduct": "اختر المادة من الشاشة الرئيسية"
  },
  "purchase": {
    "title": "شراء",
    "steps": {
      "quantity": "الكمية",
      "customer": "العميل",
      "review": "المراجعة"
    },
    "quantity": {
      "barrels": "عدد البراميل",
      "jerrycans": "عدد الجراكل",
      "deducted": "عدد الجراكل المخصومة",
      "increase": "زيادة {{label}}",
      "decrease": "إنقاص {{label}}",
      "barrelsGroup": "البراميل",
      "jerrycansGroup": "الجراكل",
      "noOptions": "لا توجد خيارات للكمية، راجع المشرف",
      "summaryTitle": "صافي الكمية",
      "summaryWords": "بالكلمات",
      "summaryJerrycans": "بالجراكل",
      "NO_CONTAINERS": "أدخل عدد البراميل أو عدد الجراكل",
      "NOT_POSITIVE": "صافي الكمية يجب أن يكون أكبر من صفر",
      "DEDUCTED_TOO_MANY_DECIMALS": "يسمح بخمس منازل عشرية كحد أقصى",
      "DEDUCTED_TOO_LARGE": "عدد الجراكل المخصومة لا يزيد عن 100000"
    },
    "customer": {
      "phone": "رقم الهاتف",
      "search": "بحث",
      "searching": "جاري البحث...",
      "searchFirst": "ابحث برقم الهاتف للمتابعة",
      "invalidPhone": "رقم الهاتف غير صحيح",
      "name": "الاسم",
      "vehiclePlate": "رقم المركبة",
      "vehicleType": "نوع المركبة",
      "optional": "اختياري",
      "vehicleNationality": "جنسية المركبة",
      "driverNationality": "جنسية السائق",
      "knownNote": "لتغيير المركبة راجع المشرف",
      "nationalityPlaceholder": "اختر الجنسية",
      "nationalitySearch": "بحث عن جنسية...",
      "nationalitiesError": "تعذر تحميل الجنسيات",
      "required": "الحقول المطلوبة مميزة بعلامة النجمة"
    },
    "review": {
      "product": "المادة",
      "operation": "نوع العملية",
      "operationValue": "شراء",
      "net": "صافي الكمية",
      "phone": "رقم الهاتف",
      "save": "حفظ",
      "saving": "جاري الحفظ..."
    },
    "discard": {
      "title": "تجاهل التغييرات؟",
      "description": "سيتم فقدان بيانات الشراء التي لم تحفظ.",
      "confirm": "تجاهل",
      "cancel": "متابعة التعديل"
    }
  },
  "result": {
    "title": "تم حفظ الشراء",
    "reference": "رقم الحركة",
    "net": "صافي الكمية",
    "product": "المادة",
    "qrLabel": "رمز QR للحركة {{reference}}",
    "print": "طباعة الوصل",
    "printing": "جاري الطباعة...",
    "printed": "تم إرسال الوصل إلى الطابعة",
    "whatsapp": "إرسال واتساب",
    "sending": "جاري الإرسال...",
    "whatsappStatus": "حالة الرسالة",
    "retry": "إعادة المحاولة",
    "newOperation": "عملية جديدة",
    "loadError": "تعذر تحميل الوصل",
    "messageStatus": {
      "queued": "بانتظار الإرسال",
      "sent": "تم الإرسال",
      "delivered": "تم التسليم",
      "read": "تمت القراءة",
      "failed": "فشل الإرسال",
      "invalid_phone": "رقم الهاتف غير صالح"
    },
    "savedPending": "حفظت الحركة معلقة حتى ترحيلها",
    "titleSale": "تم حفظ البيع",
    "saleNote": "سلم الوصل للعميل لإكمال البيع في المكتب"
  },
  "delivery": {
    "title": "مسح الوصل",
    "opening": "جاري فتح الكاميرا...",
    "scan": "مسح الوصل",
    "scanAgain": "مسح وصل آخر",
    "manual": "إدخال الرقم يدويا",
    "manualLabel": "رقم الحركة",
    "manualHint": "الرقم المطبوع على الوصل",
    "lookup": "بحث",
    "unknownCode": "رمز غير معروف",
    "searching": "جاري البحث عن الحركة...",
    "details": {
      "reference": "رقم الحركة",
      "kind": "نوع الحركة",
      "product": "المادة",
      "category": "الفئة",
      "qty": "الكمية",
      "lessJerrycans": "إلا جركل",
      "net": "صافي الكمية",
      "status": "حالة التسليم",
      "debtor": "اسم العميل",
      "vehicle": "رقم المركبة"
    },
    "kind": {
      "CASH_SALE": "بيع نقدي",
      "DEBT_SALE": "بيع ذمم",
      "PDA_SALE": "بيع PDA"
    },
    "status": {
      "PENDING": "بانتظار التسليم",
      "DELIVERED": "تم التسليم",
      "NOT_COMPLETED": "بانتظار الإكمال"
    },
    "mismatch": "مادة الوصل {{product}} تختلف عن المادة المختارة",
    "switchTo": "التبديل إلى {{product}}",
    "complete": "إتمام العملية",
    "completing": "جاري التسليم...",
    "confirmTitle": "تأكيد التسليم",
    "confirmDescription": "تأكيد تسليم كامل الكمية للحركة {{reference}}؟",
    "confirm": "تأكيد",
    "notCompleted": "لم يكتمل البيع بعد، أرسل العميل إلى المكتب لإكماله"
  },
  "recent": {
    "title": "آخر عملياتي",
    "empty": "لا توجد عمليات اليوم",
    "loadError": "تعذر تحميل العمليات",
    "open": "فتح الوصل {{reference}}",
    "noName": "بدون اسم",
    "type": "نوع العملية"
  },
  "operation": {
    "PURCHASE": "شراء",
    "SALE": "بيع"
  }
}
